<template lang="pug">
    v-content
        v-layout(row='', wrap='', align-top='')
            v-flex
                .rtl
                    v-toolbar(flat="" color="white")
                        v-toolbar-title פעולות
                        v-divider.mx-2(inset="" vertical="")
                        v-spacer

                v-tooltip(top)
                    v-btn.white--text(slot='activator' color='blue-grey' @click="deleteDialog = true")
                        |  מחק את כל הרשומות במנדי
                        //v-icon(left='', dark='') delete_outline
                    span  פעולה זו עשויה למחוק עשרות אלפי רשומות




        v-toolbar(flat="" color="white").rtl
            v-toolbar-title הגדרות
            v-divider.mx-2(inset="" vertical="")
            v-spacer
        v-dialog(v-model="dialog" max-width="400px").rtl
            v-btn.mb-2(slot="activator" color="primary" dark="") הגדרה חדשה
            v-card
                v-card-title
                    span.headline {{ formTitle }}
                v-card-text
                    v-container(grid-list-md="").rtl
                        v-layout(wrap="")
                            v-flex(xs12)
                                v-text-field(reverse right v-model="editedItem.key" label="key")
                            v-flex(xs12)
                                v-text-field(reverse right v-model="editedItem.value" label="value")
                            v-flex(xs12)
                                v-text-field(reverse right v-model="editedItem.description" label="תיאור")

                v-card-actions
                    v-spacer
                    v-btn(color="blue darken-1" flat="" @click="close") Cancel
                    v-btn(color="blue darken-1" flat="" @click="save(editedItem)") Save
        v-data-table#setting-table.elevation-1(
          :headers="headers"
          :items="desserts"
          :loading='loading'
          :rows-per-page-items="rowsPerPageItems"

        )
            template(slot="items" slot-scope="props")
                td.text-xs-right {{ props.item.id                }}
                td.text-xs-right {{ props.item.key               }}
                td.text-xs-right {{ props.item.value             }}
                td.text-xs-right {{ props.item.description       }}

                td.justify-center.layout.px-0
                    v-icon.mr-4(small="" @click="editItem(props.item)")
                        | edit
                    v-icon.mr-4(small="" @click="deleteItem(props.item)")
                        | delete
            template(slot="no-data")
                v-btn(color="primary" @click="initialize") Reset



        v-dialog(v-model='deleteDialog', max-width='300px')
            v-card.rtl
                v-card-title האם אתה בטוח שאתה רוצה למחוק את כל הרשומות בטבלת מנדי?
                v-card-text
                    v-btn(color='red darken-4', dark='', @click='deleteAll') כן, אני רוצה למחוק הכל 😎
                v-card-actions.ltr
                    v-btn(color='primary', flat='', @click='deleteDialog = false') 😮 רגע מה? לא לא אני מתחרט



</template>

<script>
    export default {
        data: () => ({
            loading: true,
            dialog: false,
            deleteDialog: false,
            headers: [
                { text: 'id'                    , value: 'id'                               , sortable: false, align : 'right'},
                { text: 'key'                   , value: 'key'                              , sortable: false, align : 'right' },
                { text: 'value'                 , value: 'value'                            , sortable: false, align : 'right' },
                { text: 'description'           , value: 'range_excel_column_end'           , sortable: false, align : 'right' },
                { text: 'פעולות'                                                            , sortable: false, align : 'right' },
            ],
            desserts: [],
            editedItem: {},
            rowsPerPageItems: [10, 20, 50, 100, 1000]
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'הגדרה חדשה' : 'ערוך'
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            }
        },

        created () {
          document.title = 'הגדרות';

          this.$socket.on('*', (packet) => {
                let channel = packet.data[0];
                let data = packet.data[1];
                let $uniqid = data.$uniqid;
                if($uniqid) {
                    return this.$socket.res(data);
                }
                this.sockets(channel, data);
            });

            this.initialize();
            this.$emit('update:loading', false);
        },
        beforeRouteLeave(to, from, next) {
            this.$socket.off('*');
            this.$emit('update:loading', true);
            next();
        },

        methods: {
            initialize () {
                this.$socket.req('general.settings.all').then(data => {
                    this.desserts = data.entities;
                    setTimeout(()=> {
                        document.getElementsByClassName('v-table__overflow')[0].scrollLeft = 20000;
                        this.loading = false;
                    });
                });
            },

            sockets : function (channel, data) {
                let channels = {
                  'sum.channel' : (/*data*/) => {
                        // log('sum.channel', data)
                    }
                };
                if(!channels[channel]) {
                    // return log('Socket channel not found:', channel);
                }

                return channels[channel](data);
            },


            editItem (item) {
                this.editedIndex = this.desserts.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                confirm(`בטוח? למחוק את
                    ${item.sheet_name}
                `) && this.$socket.req('general.settings.delete', {
                    id    : item.id
                }).then(data => {
                    
                    this.initialize();
                });
            },

            deleteAll() {
                this.$socket.req('mendi.actions.deleteAll').then(data => {
                    if(!data.err) {
                        this.$emit('update:snackbar', {
                            text : '.הטבלה נמחקה. אני מקווה שאתה יודע מה שאתה עושה',
                            show : true
                        });
                        this.deleteDialog = false;
                    }
                });
            },


            close () {
                this.dialog = false
            },

            save (item) {
                this.loading = true;
                this.$socket.req('general.settings.editOrAdd', item).then(data => {
                    let itemIdx = this.desserts.findIndex(v => v.id == data.item.id);

                    if(itemIdx > -1) {
                        // this.desserts[itemIdx] = data.item;
                        this.initialize();
                    }
                    else {
                        this.desserts.push(data.item);
                    }
                    this.loading = false;
                    this.editedItem = {};
                });
                this.close()
            }
        }
    }
</script>

<style lang="sass">

    #setting-table .v-table__overflow
        /*height: 300px;*/
        overflow-y: auto
        /*direction: rtl;*/


    #setting-table .v-datatable.v-table
        direction: rtl

    #setting-table .v-datatable__actions
        direction: ltr


    .v-content__wrap
        background: #fff
    #setting-table
        table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child)
            padding: 0 5px


</style>